import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    Input,
} from '@angular/core';
import { IconProps, IconType } from '@pf/shared-common';
import { IconMap, IIconPopover } from './icon-definitions';

@Component({
    selector: 'pf-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class IconComponent {
    private readonly elementRef = inject(ElementRef);
    private _iconType?: keyof typeof IconType;

    @Input() popover?: IIconPopover;
    @Input() rotate?: number;
    @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'lg';

    get iconClassSize(): string | null {
        return this.size ? `icon-${this.size}` : null;
    }

    iconSize: string | null = null;

    iconProps: IconProps | null = null;

    @Input() set iconType(iconType: keyof typeof IconType) {
        this._iconType = iconType;
        this.setIconProps(IconType[iconType]);
    }

    get iconType(): keyof typeof IconType | undefined {
        return this._iconType;
    }

    setIconProps(iconType: IconType): void {
        if (!IconMap.has(iconType)) {
            throw new Error(`Icon not found! ${IconType[iconType]}`);
        }

        this.iconProps = IconMap.get(iconType) as IconProps;
        this.elementRef.nativeElement.classList.add(this.iconClassSize);
    }
}
